<template>
  <div class="add-new-user">
    <HeaderPanel
      class="add-new-user__header"
      header-icon="users-apioshade3"
      :header-text="headerText"
    >
    </HeaderPanel>
    <v-card class="add-new-user__card">
      <div class="add-new-user__title apioshade2--text">You are inviting a user to access your organisation. The user will be able to access your analytics and view event contents.</div>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <div class="small-extra-bold apioshade2--text">Email Address</div>
          <form-group :validations="$v.user.email" class="form-group">
            <div slot-scope="{ errors }">
              <v-text-field
                type="email"
                :error="true"
                name="email"
                dense
                outlined
                required
                v-model="$v.user.email.$model"
                placeholder="Type here..."
                :hide-details="true"
              >
              </v-text-field>
              <div class="form-field-error">{{ errors[0] || "" }}</div>
            </div>
          </form-group>
        </v-col>
      </v-row>
      <div class="add-new-user__title mt-6 mb-0 apioshade2--text">If you tick "Build" checkbox below the user will be able to create and run apps. If you tick the "Admin" checkbox below, the user will be able to administer the organisation.</div>
      <div class="apio__checkboxes">
        <div class="apio__checkbox mr-12">
          <apio-checkbox
            label="Admin"
            :value="user.admin"
            :checked="user.admin"
            v-model="user.admin"
          />
        </div>
        <div class="apio__checkbox mr-12">
          <apio-checkbox
            label="Build"
            :value="user.build"
            :checked="user.build"
            v-model="user.build"
          />
        </div>
      </div>
    </v-card>
    <div class="apio__card-actions">
      <apio-button button-type="secondary" @click="cancel">Cancel</apio-button>
      <apio-button @click="save" :disabled="!isFormValid"
        >Invite User</apio-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  name: "AddNewUser",
  data() {
    return {
      headerText: "Invite a user to your organisation",
      title: "",
      user: {
        client: '',
        email: '',
        admin: false,
        build: false,
        role: '',
      },
    };
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
    },
  },
  mixins: [validationMixin],
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
    ApioButton: () => import("@/components/Misc/Button.vue"),
    FormGroup: () => import("@/pages/Account/FormGroup"),
  },
  computed: {
    ...mapState({
      users: (state) => state.users.users,
      clients: (state) => state.users.clientsDetails,
    }),
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  methods: {
    cancel() {
      this.$router.push("/users");
    },
    save() {
      let client = this.$route.query.c;
      var role = 'analytics';
      if (this.user.admin) {
        role = 'admin';
      } else if (this.user.build) {
        role = 'build';
      }
      if (this.isFormValid) {
        this.$store.dispatch("inviteUser", {email: this.user.email, client: client, role: role});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-user {
  margin: 16px 32px 0 32px;

  @media (max-width: 1024px) {
    margin: 12px 20px 0 20px;
  }

  &__title {
    padding-bottom: 24px;
  }

  &__header {
    padding: 0 0 20px 0;
  }

  &__card {
    padding: 16px;
  }
}
</style>
